import cn from 'classnames';
import Swiper from 'swiper';

const MAX_BULLETS = 8;

const renderCustomBullets = (swiper: Swiper, current: number, total: number): string => {
  const start = Math.floor((current - 1) / MAX_BULLETS) * MAX_BULLETS;
  const end = Math.min(start + MAX_BULLETS, total);

  const { pagination } = swiper.params;
  const bulletClass = typeof pagination === 'object' ? pagination?.bulletClass : '';
  const bulletActiveClass = typeof pagination === 'object' ? pagination?.bulletActiveClass : '';

  const bullets = [];

  for (let i = start; i < end; i++) {
    const classNames = [bulletClass];

    if (i === current - 1) {
      classNames.push(bulletActiveClass);
    }

    bullets.push(`<span class="${cn(...classNames)}"></span>`);
  }

  return bullets.join('');
};

export default renderCustomBullets;
